import React from 'react';
import ifcMessageStyles from './ifcMessage.module.pcss';

interface IfcMessageProps {
  financingPromoMessage: string | null;
  showPlaceholder: boolean;
}

function IfcMessage({ financingPromoMessage, showPlaceholder }: IfcMessageProps): React.ReactElement | null {
  const Message = financingPromoMessage && (
    <div className={ifcMessageStyles.financing}>
      <span dangerouslySetInnerHTML={{ __html: financingPromoMessage }} />
    </div>
  );
  const Placeholder = showPlaceholder && <div className={ifcMessageStyles.placeholder}>&nbsp;</div>;
  return Message || Placeholder || null;
}

export default IfcMessage;
